import i18n from '@/utils/i18n'

export const SLIP_LIST_PAGE_SIZE = 20

/** API status: 0=읽지 않음, 1=읽음, 2=전체 */
export const SLIP_FILTER = {
  UNREAD: 0,
  READ: 1,
  ALL: 2
}

export function getSlipFilterTabs () {
  return [
    { key: 'all', status: SLIP_FILTER.ALL, label: i18n.t('slip.filterAll') },
    { key: 'unread', status: SLIP_FILTER.UNREAD, label: i18n.t('slip.filterUnread') },
    { key: 'read', status: SLIP_FILTER.READ, label: i18n.t('slip.filterRead') }
  ]
}

export function getSlipLabels () {
  return {
    title: i18n.t('slip.title'),
    desc: i18n.t('slip.desc'),
    loading: i18n.t('slip.loading'),
    emptyAll: i18n.t('slip.emptyAll'),
    emptyUnread: i18n.t('slip.emptyUnread'),
    emptyRead: i18n.t('slip.emptyRead'),
    loadError: i18n.t('slip.loadError'),
    reload: i18n.t('slip.reload'),
    reloadAria: i18n.t('slip.reloadAria'),
    filterAria: i18n.t('slip.filterAria'),
    prevPage: i18n.t('slip.prevPage'),
    nextPage: i18n.t('slip.nextPage'),
    colNo: i18n.t('slip.colNo'),
    colStatus: i18n.t('slip.colStatus'),
    colTitle: i18n.t('slip.colTitle'),
    colDate: i18n.t('slip.colDate'),
    noTitle: i18n.t('slip.noTitle'),
    unreadChip (count) {
      return i18n.t('slip.unreadCount', { count })
    },
    unreadAria (count) {
      return i18n.t('slip.unreadAria', { count })
    },
    headerNotice: i18n.t('slip.headerNotice'),
    headerNoticeAria: i18n.t('slip.headerNoticeAria')
  }
}

export const SLIP_FILTER_TABS = getSlipFilterTabs()
export const SLIP_LABELS = getSlipLabels()

/** status 0 = 읽지 않음, 그 외 = 읽음 */
export function isSlipUnread (status) {
  return Number(status) === 0
}

export function slipStatusLabel (status) {
  return isSlipUnread(status) ? i18n.t('slip.statusUnread') : i18n.t('slip.statusRead')
}

export function slipStatusClass (status) {
  return isSlipUnread(status) ? 'slip-status--unread' : 'slip-status--read'
}

export function normalizeSlipList (payload) {
  if (!payload) return []
  const list = Array.isArray(payload.list) ? payload.list : []
  return list.filter(item => item && item.idx != null)
}

export function resolveSlipTotal (payload) {
  if (!payload) return 0
  const total = Number(payload.total)
  if (Number.isFinite(total) && total >= 0) return total
  return normalizeSlipList(payload).length
}

export function slipEmptyMessage (filterKey) {
  const labels = getSlipLabels()
  if (filterKey === 'unread') return labels.emptyUnread
  if (filterKey === 'read') return labels.emptyRead
  return labels.emptyAll
}

export function countUnreadSlips (list) {
  if (!Array.isArray(list)) return 0
  return list.filter(item => isSlipUnread(item.status)).length
}

export function resolveSlipUnreadCount (payload) {
  if (!payload) return 0
  const list = normalizeSlipList(payload)
  return countUnreadSlips(list)
}

/** gateway/runtime 응답 data.slips (미읽음 개수) */
export function resolveRuntimeSlipUnreadCount (data) {
  if (!data || data.slips == null) return 0
  const slips = data.slips
  if (Array.isArray(slips)) {
    return countUnreadSlips(slips)
  }
  const count = Number(slips)
  if (!Number.isFinite(count) || count <= 0) return 0
  return Math.floor(count)
}
